<icz-card class="icz-body-1">
  <div class="row-group items-center" [class.cursor-pointer]="isContentExpandable" (click)="toggleExpansionState()" role="button">
    <div class="object-icon">
      <icz-object-class-icon [objectClass]="associatedObjectClass" class="mr-8"></icz-object-class-icon>
    </div>
    <div>
      <span class="mr-4 ml-16">{{heading | translate}}</span>
      <ng-content select="[afterHeading]"></ng-content>
    </div>
    @if (isContentExpandable) {
      <div class="grow"></div>
      <icz-icon size="small" class="mr-24" [svgIcon]="isContentExpanded ? 'collapse' : 'expand_more'"></icz-icon>
    }
  </div>
  @if (!isContentExpandable || isContentExpanded) {
    <div class="content">
      <ng-content></ng-content>
    </div>
  }
</icz-card>
